import { ref } from 'vue';

const VitalSignsByServiceCategory = {
    startDate: '',
    endDate: ''
};

const InvoiceSummary = {
    startDate: '',
    endDate: ''
};

const ServicePackageSales = {
    startDate: '',
    endDate: ''
};

const TechnicianSummary = {
    startDate: '',
    endDate: ''
};

// Enterprise
const TechnicianSummaryEnterprise = {
    startDate: '',
    endDate: ''
};

const ServiceAdvisorSummaryEnterprise = {
    startDate: '',
    endDate: ''
};

const SalesSummaryEnterprise = {
    startDate: '',
    endDate: ''
};

const updateState = (stateObject: object, updates: object) => {
    Object.assign(stateObject, updates);
    updateButtonReport();
};

export const getReportButton = ref(true);

export const updateButtonReport = () => {
    getReportButton.value = true;
};

export const setVitalSignsByServiceCategory = (startDate: '', endDate: '') => {
    updateState(VitalSignsByServiceCategory, { startDate, endDate });
};

export const setInvoiceSummary = (startDate: '', endDate: '') => {
    updateState(InvoiceSummary, { startDate, endDate });
};

export const setServicePackageSales = (startDate: '', endDate: '') => {
    updateState(ServicePackageSales, { startDate, endDate });
};

export const setTechnicianSummary = (startDate: '', endDate: '') => {
    updateState(TechnicianSummary, { startDate, endDate });
};

export const getVitalSignsByServiceCategory = () => {
    return `startDate=${VitalSignsByServiceCategory.startDate}&endDate=${VitalSignsByServiceCategory.endDate}`;
};

export const getInvoiceSummary = () => {
    return `startDate=${InvoiceSummary.startDate}&endDate=${InvoiceSummary.endDate}`;
};

export const getServicePackageSales = () => {
    return `startDate=${ServicePackageSales.startDate}&endDate=${ServicePackageSales.endDate}`;
};

export const getTechnicianSummary = () => {
    return `startDate=${TechnicianSummary.startDate}&endDate=${TechnicianSummary.endDate}`;
};

export const getTechnicianSummaryEnterprise = () => {
    return `startDate=${TechnicianSummaryEnterprise.startDate}&endDate=${TechnicianSummaryEnterprise.endDate}`;
};

export const getServiceAdvisorSummaryEnterprise = () => {
    return `startDate=${ServiceAdvisorSummaryEnterprise.startDate}&endDate=${ServiceAdvisorSummaryEnterprise.endDate}`;
};

export const getSalesSummaryEnterprise = () => {
    return `startDate=${SalesSummaryEnterprise.startDate}&endDate=${SalesSummaryEnterprise.endDate}`;
};

export const setTechnicianSummaryEnterprise = (startDate: '', endDate: '') => {
    updateState(TechnicianSummaryEnterprise, { startDate, endDate });
};

export const setServiceAdvisorSummaryEnterprise = (startDate: '', endDate: '') => {
    updateState(ServiceAdvisorSummaryEnterprise, { startDate, endDate });
};

export const setSalesSummaryEnterprise = (startDate: '', endDate: '') => {
    updateState(SalesSummaryEnterprise, { startDate, endDate });
};